export default {
  ctaText: "Markdown price",
  sidePanelSubtitle: "These are the evening results.",
  sidePanelTitle: "Results!",
  tagLabel: "Evening"
};
